/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for creating a team in a public user event; the caller becomes its first member.
 * @export
 * @interface TeamCreate
 */
export interface TeamCreate {
    /**
     * 
     * @type {string}
     * @memberof TeamCreate
     */
    name?: string | null;
}

/**
 * Check if a given object implements the TeamCreate interface.
 */
export function instanceOfTeamCreate(value: object): value is TeamCreate {
    return true;
}

export function TeamCreateFromJSON(json: any): TeamCreate {
    return TeamCreateFromJSONTyped(json, false);
}

export function TeamCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function TeamCreateToJSON(json: any): TeamCreate {
    return TeamCreateToJSONTyped(json, false);
}

export function TeamCreateToJSONTyped(value?: TeamCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

